interface LoadingState {
  isLoading: boolean;
  promise?: Promise<any>;
  timestamp: number;
}

const loadingStates = new Map<string, LoadingState>();
const CACHE_FRESHNESS_MS = 10 * 60 * 1000;

const getCacheKey = (key: string): string => {
  const cacheKeys: Record<string, string> = {
    metadata: "metadata:app",
    tasks: "tasks:list",
    meetings: "meetings:list",
    projects: "projects:list",
    opportunities: "opportunities:list",
  };
  return cacheKeys[key] || key;
};

export const shouldLoadData = async (
  key: string,
  storedData: string | null,
): Promise<boolean> => {
  const loadingState = loadingStates.get(key);
  if (loadingState?.isLoading) {
    return false;
  }

  const cacheKey = getCacheKey(key);

  try {
    const cacheModule = await import("../storage/cacheManager");
    const cache = await cacheModule.initCache();
    const normalizedKey = cacheKey.startsWith("/cache/")
      ? cacheKey
      : `/cache/${cacheKey}`;
    const request = new Request(normalizedKey);
    const cachedResponse = await cache.match(request);

    if (cachedResponse) {
      const cachedEntry = await cachedResponse.json();
      if (cachedEntry && cachedEntry.timestamp) {
        const age = Date.now() - cachedEntry.timestamp;
        if (age < CACHE_FRESHNESS_MS) {
          return false;
        }
      }
    }
  } catch (e) {}

  return true;
};

export const setLoading = (key: string, promise: Promise<any>): void => {
  loadingStates.set(key, {
    isLoading: true,
    promise,
    timestamp: Date.now(),
  });
};

export const clearLoading = (key: string): void => {
  loadingStates.delete(key);
};

export const getLoadingPromise = (key: string): Promise<any> | null => {
  const state = loadingStates.get(key);
  return state?.isLoading ? state.promise || null : null;
};

export const setCacheTimestamp = (key: string): void => {};
